import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Media,
  Row,
  Spinner,
  Table,
} from "reactstrap";
// core components
import OnlyHeader from "components/Headers/OnlyHeader.js";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { getSkillsAction } from "store/actions/skillsAction";
import AddSkillModal from "components/Modals/skillsModals/AddSkillModal";
import { skillSearchByTitleAction } from "store/actions/skillsAction";
import EditSkillModal from "components/Modals/skillsModals/EditSkillModal";
import DeleteSkillModal from "components/Modals/skillsModals/DeleteSkillModal";

const Skills = () => {
  const { allSkills, getSkillsLoader, totalPages } = useSelector(
    (state) => state.skills
  );
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteSubModalOpen] = useState(false);
  const [selectedSkill, setSelectedSkill] = useState("");
  const [skillSearchTitle, setSkillSearchTitle] = useState("");

  const itemsPerPage = 10;
  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const toggleEditModal = (skill) => {
    setSelectedSkill(skill);
    setEditModalOpen(!isEditModalOpen);
  };

  const handleDeleteModal = (id) => {
    setSelectedSkill(id);
    setDeleteSubModalOpen(!isDeleteModalOpen);
  };

  const handleOnSumbit = () => {
    dispatch(skillSearchByTitleAction(skillSearchTitle));
  };

  const handleClearSearch = () => {
    setSkillSearchTitle("");
    dispatch(getSkillsAction(currentPage, itemsPerPage));
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);

    const formattedDate = date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "UTC",
    });

    return formattedDate;
  };

  useEffect(() => {
    dispatch(getSkillsAction(currentPage, itemsPerPage));
  }, [dispatch, currentPage, itemsPerPage]);

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row className="mb-5">
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="d-flex flex-column justify-content-between align-items-center flex-xl-row">
                  <Col className="col-12 col-lg-4">
                    <h3 className="text-center text-xl-left">Skills</h3>
                  </Col>
                  <Col className="d-flex flex-column flex-lg-row justify-content-around align-items-center align-items-lg-start">
                    <div className="w-100 w-sm-50">
                      <FormGroup className="mb-0 w-100">
                        <Input
                          id="ResolutionSearch"
                          name="Search"
                          placeholder="Search Here..."
                          type="text"
                          value={skillSearchTitle}
                          onChange={(e) => setSkillSearchTitle(e.target.value)}
                        />
                      </FormGroup>
                      <small className="text-xs text-primary">
                        Search by Skill
                      </small>
                    </div>
                    <div>
                      <Button
                        color="primary"
                        className="px-10 py-2 mx-1 my-2 my-lg-0"
                        disabled={getSkillsLoader}
                        onClick={handleOnSumbit}
                        size="sm"
                      >
                        Search
                      </Button>
                      <Button
                        color="primary"
                        className="p-2 mx-1 my-2 my-lg-0"
                        size="sm"
                        onClick={handleClearSearch}
                      >
                        Clear Search
                      </Button>
                      <Button
                        color="primary"
                        className="p-2 mx-1 my-2 my-lg-0"
                        size="sm"
                        onClick={toggleModal}
                      >
                        Add New Skill
                      </Button>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Created At</th>
                    <th scope="col">Updated At</th>
                    <th scope="col">Skill</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                {!getSkillsLoader ? (
                  <tbody>
                    {allSkills && allSkills.length > 0 ? (
                      allSkills?.map((skill, index) => (
                        <tr key={index}>
                          <td scope="row">
                            <Media className="align-items-center">
                              <Media>
                                <span className="mb-0 text-sm">
                                  {formatTimestamp(skill?.createdAt)}
                                </span>
                              </Media>
                            </Media>
                          </td>
                          <td scope="row">
                            <Media className="align-items-center">
                              <Media>
                                <span className="mb-0 text-sm">
                                  {formatTimestamp(skill?.updatedAt)}
                                </span>
                              </Media>
                            </Media>
                          </td>
                          <td scope="row">
                            <Media className="align-items-center">
                              <Media>
                                <span className="mb-0 text-sm">
                                  {skill?.name}
                                </span>
                              </Media>
                            </Media>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <Button
                                color="success"
                                size="sm"
                                onClick={() => toggleEditModal(skill)}
                              >
                                <i className="fas fa-pencil-alt" />
                              </Button>
                              <Button
                                color="danger"
                                className="mx-2"
                                size="sm"
                                onClick={() => handleDeleteModal(skill._id)}
                              >
                                <i className="fa fa-trash"></i>
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" style={{ textAlign: "center" }}>
                          {allSkills && allSkills.length === 0 ? (
                            <p className="mb-0 text-sm">No Skill found.</p>
                          ) : (
                            <Spinner
                              size="lg"
                              style={{
                                display: "block",
                                margin: "0 auto",
                              }}
                            />
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center" }}>
                        <Spinner
                          size="lg"
                          style={{
                            display: "block",
                            margin: "0 auto",
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>
                )}
              </Table>
              {totalPages > 0 && (
                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <ReactPaginate
                      previousLabel={"<"}
                      nextLabel={">"}
                      breakLabel={"..."}
                      breakClassName={"break-me"}
                      pageCount={totalPages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={handlePageChange}
                      containerClassName={
                        "pagination px-1 justify-content-end mb-0"
                      }
                      activeClassName={"active"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      nextClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextLinkClassName={"page-link"}
                    />
                  </nav>
                </CardFooter>
              )}
            </Card>
          </div>
        </Row>
      </Container>

      <AddSkillModal
        modal={isModalOpen}
        toggle={toggleModal}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
      />

      <EditSkillModal
        modal={isEditModalOpen}
        toggle={() => toggleEditModal()}
        skill={selectedSkill}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
      />

      <DeleteSkillModal
        modal={isDeleteModalOpen}
        toggle={() => handleDeleteModal()}
        id={selectedSkill}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
      />
    </>
  );
};

export default Skills;
